import { graphql } from '@/generated/gql';

export const SOURCING_CASE_QUOTE_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateSourcingCaseQuote($id: UUID!, $data: TsrctSourcingCaseQuoteInput!) {
    tesseract {
      sourcingCase(id: $id) {
        updateQuote(data: $data) {
          id
          sequenceNumber
          createdAt
          updatedAt
          supplier {
            id
            name
            supplierId
            contact {
              id
              firstName
              lastName
              email
              internalId
            }
          }
          quote {
            id
            createdAt
            currency
            supplierReference
            validFrom
            validTo
            paymentTermsId
            incoTermsId
            lineItems {
              id
              sequence
              createdAt
              title
              description
              unitId
              commodityId
              deliveryLocationId
              status
              organizationId
              priceUnit
              quantity
            }
          }
        }
      }
    }
  }
`);
